import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import {
  TableRow,
  TableCell,
  OverflowMenu,
  OverflowMenuItem,
  ModalFooter,
  ComposedModal,
  ModalHeader,
  ModalBody,
  Loading,
  Button
} from 'carbon-components-react';
import { APP } from 'app/AppRoutes';

import DisplayPreview from './DisplayPreview';
import { fetchEmailWithDetail } from 'services/searchEmail.service';
import { resendEmails } from 'services/emails.service';
import { direction_type } from '../types';
import { getAttachment } from './utils';
import { CloudDownload16 } from '@carbon/icons-react';
interface Email {
  id: string;
  body: any;
  Attachments: Array<any>;
  setApiError: () => void;
}

const DisplayEmailRow: React.FC<any> = ({
  row,
  getRowProps,
  direction,
  setApiError,
  handleSendToOther
}: any) => {
  const [email, setEmail] = useState<Email | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const handleResend = async () => {
    try {
      setIsLoading(true);
      return await resendEmails({ emailId: row?.id });
    } catch (err) {
      setApiError('Error fetching resend emails');
    } finally {
      row.cells[6].value = true;
      setIsLoading(false);
    }
  };
  const fetchEmailDetails = async () => {
    try {
      setIsLoading(true);
      return await fetchEmailWithDetail({
        direction: direction,
        emailId: row?.id
      });
    } catch (err) {
      setApiError('Error fetching  emails details');
    } finally {
      setIsLoading(false);
    }
  };
  const handleFetchPreviewEmail = async () => {
    try {
      const response: any = await fetchEmailDetails();
      setEmail(response);
    } catch (err) {
      setApiError('Error fetching preview emails');
      throw err;
    }
  };

  const handleDownload = async () => {
    try {
      setIsLoading(true);
      const response: any = await fetchEmailDetails();
      const attachment: any = response?.Attachments.filter(
        (item: any) => item.mimeType === 'message/rfc822'
      ).shift();
      getAttachment({
        url: attachment.url,
        attachmentName: attachment.name,
        setApiError
      });
    } catch (err) {
      setApiError('Error fetching preview emails');
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const modalProps = {
    open: email !== undefined,
    onClose: () => setEmail(undefined)
  };

  return (
    <>
      {email &&
        ReactDOM.createPortal(
          <div className="search-emails-preview-emails">
            <ComposedModal {...modalProps}>
              <ModalHeader label="Preview email">
                {row.cells[3].value}
                <div className="search-emails-display-attachments">
                  {email?.Attachments?.filter(
                    (item: any) => item.mimeType !== 'message/rfc822'
                  ).map((attachment: any) => {
                    return (
                      <Button
                        key={attachment.id}
                        kind="tertiary"
                        renderIcon={CloudDownload16}
                        onClick={() =>
                          getAttachment({
                            url: attachment.url,
                            attachmentName: attachment.name,
                            setApiError
                          })
                        }
                      >
                        {attachment.name}
                      </Button>
                    );
                  })}
                </div>
              </ModalHeader>
              <ModalBody>
                <DisplayPreview email={email} />
              </ModalBody>
              <ModalFooter
                primaryButtonText="Close"
                onClick={() => setEmail(undefined)}
              />
            </ComposedModal>
          </div>,
          document.querySelector(`#${APP}`) || document.body
        )}
      <TableRow {...getRowProps({ row })}>
        <TableCell key={'sent'}>{row.cells[0].value}</TableCell>
        <TableCell key={'to'}>
          <div>{row.cells[1].value}</div>
          <div>{row.cells[2].value}</div>
        </TableCell>
        <TableCell key={'subject'}>{row.cells[3].value}</TableCell>
        <TableCell key={'attachment'}>{row.cells[4].value}</TableCell>
        <TableCell key={'status'}>{row.cells[5].value}</TableCell>
        {direction === direction_type.OUTBOUND && <TableCell />}
        {
          <TableCell key="overflow" className="bx--table-column-menu">
            {direction === direction_type.OUTBOUND && (
              <OverflowMenu light flipped>
                <OverflowMenuItem
                  disabled={row.cells[6].value}
                  itemText="Resend email"
                  onClick={handleResend}
                />
                <OverflowMenuItem
                  disabled={row.cells[6].value}
                  itemText="Send to other"
                  onClick={() => handleSendToOther(row.id)}
                />
                <OverflowMenuItem
                  itemText="Preview email"
                  onClick={handleFetchPreviewEmail}
                />
              </OverflowMenu>
            )}
            {direction !== direction_type.OUTBOUND && (
              <OverflowMenu light flipped>
                <OverflowMenuItem
                  itemText="Download email"
                  onClick={handleDownload}
                ></OverflowMenuItem>
                <OverflowMenuItem
                  itemText="Preview email"
                  onClick={handleFetchPreviewEmail}
                ></OverflowMenuItem>
              </OverflowMenu>
            )}
          </TableCell>
        }
      </TableRow>
      {isLoading &&
        ReactDOM.createPortal(
          <Loading withOverlay={true} />,
          document.querySelector(`#${APP}`) || document.body
        )}
    </>
  );
};
DisplayEmailRow.displayName = 'DisplayEmailRow';
export default DisplayEmailRow;
